//
// A singleton-like function available globally as window.page
// Getters/Setters for global data and functions needed within HTML script tags
//
export default class Page {
  static instance;

  // New Page function instance, bound to window.page
  // Accepts one or more data objects and sets their data safely to _props
  static init (...objs) {
    let page = new Page();

    objs.forEach((obj) => {
      for (let key in obj) {
        if (page._props[key]) throw ReferenceError(`'${key}' has already been set.`);
        page.set(key, obj[key]);
      };
    });

    window.page = page;
  }

  // Constructor that will return privately stored instance if it already exists
  constructor () {
    if (Page.instance) return Page.instance;

    Page.instance = this;
    this._props   = {};
  }

  // General purpose set to store data and functions on page scope
  // Attempting to override a _prop value will throw an error
  set (k, v) {
    this._props[k] = v;
  }

  // General purpose return boolean value based on key existance
  has (k) {
    return this._props.hasOwnProperty(k);
  }

  // General purpose get to access data and functions from page scope
  get (k) {
    if (this._props[k]) return this._props[k];
    throw ReferenceError(`'${k}' has not been set.`);
  }

  // Useful for easily initializing function constructors that are stored within _props,
  //   without having to deal with clunky `new (page.get(funcName))(a,b,c)` syntax everywhere
  init (fname, ...args) {
    const func = this.get(fname);
    return new (func)(...args);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/lib/page.js